<template>
<div class="animated fadeIn">
        <spinner v-if="loading"/>
    <b-row>
        <b-col sm="12">
            <b-card v-if="getRowCount(searchResults) <=0">
                <div slot="header">
                    <strong>Stock Balance Record</strong>
                </div>
                <b-row>
                    <b-col sm="6">
                        <b-form-group>
                            <label>Country</label>
                                <countryLookup v-bind:url="apiCountryLookup" v-on:selected="setCountry($event)" :lookupId="filter.country_id"/>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="filter.country_id != '' && warehouses.length > 0">
                    <b-col sm="12">
                         <b-form-group>
                                <label class="checkcontainer">{{ allSelected ? 'Un-select All Warehouses' : 'Select All Warehouses' }}
                                    <input type="checkbox" v-model="allSelected" @click="selectAll">
                                    <span class="checkmark"></span>
                                </label>
                            <b-form-checkbox-group v-for="option in warehouses">
                                <label class="checkcontainer">{{option}}
                                    <input type="checkbox":value="option" v-model="selectedLocations" @click="select">
                                    <span class="checkmark"></span>
                                </label>
                            </b-form-checkbox-group>
                          </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if = "filter.country_id!='' && warehouses.length <= 0">
                    <b-col sm="12">
                        <div align="left">No Warehouses Found in the selected Country!Please Select Different Country.</div>
                        <br/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="6">
                            <b-form-group>
                                <b-form-group>
                                    <label>As At Date</label>
                                        <b-form-input type="date" v-model="filter.asof_date" :disabled="lockEntry"></b-form-input>
                                </b-form-group>
                            </b-form-group>
                    </b-col>
                </b-row>
                <div slot="footer">
                    <b-button type="submit" size="lg" variant="primary" @click="search">Search</b-button>
                </div>
            </b-card>
        </b-col>
    </b-row>
    <b-row v-if="getRowCount(searchResults) > 0 && !loading">
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Stock Balance Record</strong>
                    </div>
                    <div class="table-responsive">
                        <b-table class="table-hover" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="searchResultsFields" :current-page="currentPage" 
                            :per-page="perPage" :items="searchResults" >
                        </b-table>
                    </div>
                    <nav>
                        <b-pagination :total-rows="getRowCount(searchResults)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                    </nav>
                    <div slot="footer">
                        <exportExcel
                            class   = "btn btn-primary btn-lg"
                            size ="lg"
                            :data   = "searchResults"
                            :fields = "exportHeaders"
                            name    = "sbr.xls">
                            Export to Excel
                        </exportExcel>
                        &nbsp;&nbsp;
                    <b-button type="button" size="lg" variant="success" @click="print">Print</b-button>
                    &nbsp;&nbsp;
                    <b-button type="submit" size="lg" variant="danger" @click="back">Back</b-button>
                    </div>
                </b-card>
            </b-col>
    </b-row>
    <b-row v-else-if="noResults && !loading" >
        <b-col sm="12">
            <div align="center">
                <strong>No Stock Balance Records Found</strong>
            </div>                    
        </b-col>
    </b-row>
</div>
</template>
<script>
import axios from 'axios'
import spinner from '@/components/Spinner.vue'
import countryLookup from '@/components/Autocomplete.vue'
import warehouseLookup from '@/components/Autocomplete.vue'
import productLookup from '@/components/Autocomplete.vue'
import exportExcel from 'vue-json-excel' 
import {authHeader, apiCountryLookup, apiWarehouseLookup, apiProductLookup, apiGROSave, apiStockcard,apiSbrSearch} from '@/functions/common.vue'
import Multiselect from 'vue-multiselect';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  pdfMake.fonts = {
      "ukai": {
         normal: 'ukai.ttf',
          bold: 'ukai.ttf',
          italics: 'ukai.ttf',
           bolditalics: 'ukai.ttf'
      },
   };

export default
{
    components: {countryLookup,warehouseLookup,productLookup,spinner,exportExcel,Multiselect},
    props: 
    {
        hover: {
        type: Boolean,
        default: false
        },
        striped: 
        {
        type: Boolean,
        default: false
        },
        bordered: {
        type: Boolean,
        default: false
        },
        small: {
        type: Boolean,
        default: false
        },
        fixed: {
        type: Boolean,
        default: false
        }
    },
    data: () => 
    {
        return {
            allSelected:false,
            indeterminate: false,
            loading: false,
            apiCountryLookup:apiCountryLookup,
            apiWarehouseLookup:apiWarehouseLookup,
            apiProductLookup:apiProductLookup,
            lockEntry:false,
            errorMessage:'',
            searchResults: [],
            warehouses:[],
            selectedLocations:[],
            location_id:'',
            country_id:'',
            exportHeaders:
            {
                'Stock Location': 'location_id',
                'Product Code': 'product_id',
                'Product Name': 'product_name',
                'SOH': 'qty_soh',
                'Unit GMP':'unit_gmp',
                'Total GMP':'total_gmp'
            },
            filter: 
            {
                country_id: '',
                selectedWarehouses:[],
                asof_date: ''
            }, 
            searchResultsFields:
            [
                {key: 'location_id', label: 'Stock Location'},
                {key: 'product_id' ,label: 'Product Code'},
                {key: 'product_name' ,label: 'Product Name'},
                {key: 'qty_soh' ,label: 'SOH','class': 'text-right'},
                {key: 'unit_gmp' ,label: 'Unit GMP','class': 'text-right'},
                {key: 'total_gmp' ,label: 'Total GMP','class': 'text-right'},
            ],
                currentPage: 1,
                perPage: 20,
                totalRows: 0,
                noResults: false 
        }
    },
    watch: {
    selectedLocations (newVal, oldVal) {
      // Handle changes in individual flavour checkboxes
      if (newVal.length === 0) {
        this.allSelected = false
      } else if (newVal.length === this.warehouses.length) {
        this.allSelected = true
      } else {
        this.allSelected = false
      }
    }
  },
    methods:
    {
        selectAll: function() 
        {
            this.selectedLocations = [];

            if (!this.allSelected) 
            {
                for (let w in this.warehouses) {
                    this.selectedLocations.push(this.warehouses[w]);
                }
            }
        },
        select: function() 
        {
            this.allSelected = false;
        },
        print()
        {
          var rows = []
          var row = []
          var date = new Date()
          var total_soh_print = 0;
          var total_gmp_amount_print = 0;
          var header = [
                        {
                            text: 'Stock Location',
                        },
                        {
                            text: 'Product Code',
                            alignment: 'left'
                        },
                        {
                            text: 'Description',
                            alignment: 'left'
                        },
                        {
                            text: 'SOH',
                            alignment: 'right'
                        },
                        {
                            text: 'Unit GMP',
                            alignment: 'right'
                        },
                        {
                            text: 'Total GMP',
                            alignment: 'right'
                        },
                    ]
          rows.push(header)

          for (let key in this.searchResults)
          {
            var data = this.searchResults[key]
           // row = [data.location_id, data.product_id,data.product_name, data.qty_soh, data.unit_gmp, data.total_gmp]
            row = [
                            {
                                text: data.location_id,
                            },
                            {
                                text: data.product_id,
                            },
                            {
                                text: data.product_name,
                            },
                            {
                                text: data.qty_soh,
                                alignment:'right'
                            },
                            {
                                text: data.unit_gmp,
                                alignment:'right'
                            },
                            {
                                text: data.total_gmp,
                                alignment:'right'
                            },
                        ]
            
            rows.push(row)
          }
          var data= 
          [
            {text: " "},
            {text: " "},
            {text: "TOTAL",bold:true,fontSize:10},
            {text: total_soh_print,bold:true,fontSize:10,alignment: 'right'},
            {text:" "},
            {text:total_gmp_amount_print,bold:true,fontSize:10,alignment: 'right'}
          ]
          //rows.push(data)
          var dd = {
            pageSize: 'A4',
            pageOrientation: 'portrait',
            header:{ text: 'Stock Balance Record generated on'+ " "+ date, margin: [ 5, 10, 10, 30 ],alignment: 'center',fontSize:8 },
            // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
            pageMargins: [30, 20, 30, 20 ],
            defaultStyle: {
                font: 'ukai'
            },
            content: [
            {text:'Stock Balance Record',fontSize:8,margin:[0,10,0,0],bold: true,},
              {
                margin:[0,10,0,0],
                fontSize: 8,
                layout: 'lightHorizontalLines', // optional
                table: {
                  headerRows: 1,
                  widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],

                  body: 
                    rows
                  
                }
              },
            ]
          };

          pdfMake.createPdf(dd).open();
        },
        setCountry(obj)
        {
              var id
              if (obj !== null)
              {
                id = obj.id
                
                if(id !='')
                {
                    axios.get(apiWarehouseLookup,{params: {q: this.lookupValue, q2: id,limit:9999}})
                    .then (res => { 
                        var list
                        list = res.data.data.list
                        var data 
                        var isDuplicate = false
                        this.warehouses = []
                        this.selectedLocations = []
                        if(list.length >0)
                        {

                            for (let data in list)
                            {
                                
                                data = list[data].location_id + ' - ' + list[data].location_name
                                for(let i=0; i<this.warehouses.length; i++)
                                {
                                    if(this.warehouses[i] == data)
                                    {
                                        isDuplicate = true
                                    }
                                }
                                if(isDuplicate == false)
                                {
                                    this.warehouses.push(data)
                                }
                            }

                        }
                    })
                    .catch(error => alert(error))

                }
                else
                {
                    this.selectedLocations = []
                }
              } 
              else
              {
                id = null
              }
              this.filter.country_id = id
        },
        search()
        { 
            var selectedWH = this.selectedLocations
            this.filter.selectedWarehouses = []
            if(selectedWH.length > 0)
            {
                for(let n=0; n < selectedWH.length; n++)
                {
                    var str = selectedWH[n]
                    var res
                    for (let i=0; i < str.length;i++)
                    {         
                        if (str[i] == '-')
                        {
                            res = str.substring(0, i);
                            this.filter.selectedWarehouses.push(res)
                            break
                        }
                    }
                   
                }
            }
            else
            {
                console.log("No warehouse is being selected")
            }
            var total_soh = 0;
            var total_gmp_amount = 0;
            var sf =
            {
                "warehouses_list":this.filter.selectedWarehouses
                ,"asof_date" : this.filter.asof_date
            } 
            axios.post(apiSbrSearch, sf,authHeader())
                .then (res => 
                {
                    return res
                })
                .then (data =>
                {
                    
                    var results = data.data.data.list
                    //console.log(results)
                    var qty_soh 
                    var unit_gmp
                    var total_gmp
                    var total_soh = 0
                    var total_gmp_amount =0
                    if(results.length > 0)
                    {
                        for (var n=0; n<results.length; n ++ )
                        {
                            
                            qty_soh = results[n].qty_soh *1
                            unit_gmp = results[n].unit_gmp * 1
                            total_gmp = results[n].total_gmp*1
                            
                            total_soh = total_soh + qty_soh
                            total_gmp_amount = total_gmp_amount + total_gmp

                            qty_soh = qty_soh.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

                            unit_gmp = unit_gmp.toFixed(2)
                            unit_gmp = unit_gmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            
                            total_gmp = total_gmp.toFixed(2)
                            total_gmp = total_gmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

                            results[n].qty_soh = qty_soh
                            results[n].unit_gmp = unit_gmp
                            results[n].total_gmp = total_gmp
                        }
                    }
                    this.searchResults = results

                    total_soh = (total_soh *1)
                    total_soh = total_soh.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

                    total_gmp_amount = (total_gmp_amount *1).toFixed(2)
                    total_gmp_amount = total_gmp_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    
                    this.loading = false
                    this.noResults = true
                })
                .catch(error => alert(error))
        },
        setProduct(obj)
        {
            var id 
            if (obj!== null)
            {
                id=obj.id
            }
            else
            {
                id=null
            }
            this.filter.product_id = id
        },
        getRowCount (list) 
        {
            return list.length
        },
        back()
        {
            this.filter.country_id =''
            this.filter.selectedWarehouses =[]
            this.filter.asof_date =''
            this.noResults = false
            this.searchResults = []
            this.selectedLocations = []
            //location.reload()

        }
    }

}
</script>
<style>
.main {overflow-x: overlay;overflow-y: overlay;overflow:hidden;}
.checkcontainer {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkcontainer input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 19px;
  width: 19px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.checkcontainer:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.checkcontainer input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkcontainer input:checked ~ .checkmark:after {
  display: block;
}
/* Style the checkmark/indicator */
.checkcontainer .checkmark:after {
  left: 7px;
  top: 4px;
  width: 5px;
  height: 9px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>


// WEBPACK FOOTER //
// src/views/sm/sbr.vue